// Vendor libraries
import { CommonModule } from '@angular/common';
import * as i0 from "@angular/core";
export class PieChartModule {
}
PieChartModule.ɵfac = function PieChartModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PieChartModule)(); };
PieChartModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PieChartModule });
PieChartModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule] });
